/*
 * @Author: your name
 * @Date: 2022-03-24 16:04:26
 * @LastEditTime: 2022-04-13 10:41:05
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /xyf-mobile-frontend/src/service/land.js
 */
import { requestLandDevice } from '@/utils/requestLandDevice';
import { requestLandProxy } from '@/utils/requestLandProxy';
import { requestLandProxyWeiXin } from '@/utils/requestLandProxyWeiXin';
import { requestLand } from '@/utils/requestLand';
import { requestWei } from '@/utils/requestWei';
import { requestLandMobileGw } from '@/utils/requestLandMobileGw';
import { encode } from '../utils/base64'
import {getLandAb, getSessionToken, terminalFn} from "@/utils";
//查询手机号或openid绑定状态
export async function getWechatStatus(params) {
  return requestWei.post(`/wechat/bindInfo`, params);
}
//绑定/换绑
export async function getWechatBind(params) {
  return requestWei.post(`/wechat/bind`, params);
}

function getRandomIntInRange(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export async function checkAb(name, params, requestOptions = {}) {
  let ab = getLandAb();
  // landing-page/get-url 这个接口初始化调用 不走灰度接口判断

  if (!ab) {
    return requestLand.post(name, params, requestOptions);
  } else {
    if (name.indexOf('get-gray-contract-config') > -1) {
      return ["XYF05", "XYF02", "XYF01"].includes(params.args.type) ? {
        response: {
          "mobileTailNos": "01,02,03,04,05,06,07,08,09,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99"
        },
        status: 1
      } : {
        response: {}
      }
    }
    if (name.indexOf('confirm-v-code') > -1) {
      params.args = Object.assign(params.args, {
        action_type: "action_mobile",
        url: encodeURIComponent(location.href),
        action_val: {
          encrypted_mobile: params.args.encrypted_mobile,
          mobile: params.args.mobile,
          verification_code: params.args.verification_code,
        },
        os: terminalFn(),
        ua: 'h5-client'
      })
      if (params.args.xc_mk || params.args.xc_rgs) {
        params.args.ext_data = JSON.stringify({
          xc_mk: params.args.xc_mk,
          xc_rgs: params.args.xc_rgs,
        });
      }
      const filterArr = ['action_type', 'url', 'action_val', 'ext_data', 'os', 'ua', 'utm_source', 'type', 'vid', 'channel'];
      // 只保留 filterArr 中的自有键
      Object.keys(params.args).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(params.args, key) && !filterArr.includes(key)) {
          delete params.args[key];
        }
      });
      params.call = 'land-page/userActions';
      return requestLandProxy.post('/land-page/userActions', params, requestOptions)
    }
    return requestLandProxy.post(name, params, requestOptions);
  }
}

//落地页配置数据
export async function getLyntxData (params) {
  const data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/get-schema'
  }, data);
  return requestLand.post(`/landing-page/get-schema`, params);
}

//获取协议灰度配置
export async function getGrayContractConfig (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/get-gray-contract-config'
  }, data);
  return checkAb(`/landing-page/get-gray-contract-config`, params);
}
//获取落地页最高额度
export async function getCsToken (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/customer-service-profile'
  }, data);
  return requestLand.post(`/landing-page/customer-service-profile`, params);
}
//获取落地页最高额度
export async function getShowAmount (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/show-amount'
  }, data);
  return requestLand.post(`/landing-page/show-amount`, params);
}
//落地页灰度配置
export async function getGrayConfig (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/get-gray-config'
  }, data);
  return requestLand.post(`/landing-page/get-gray-config`, params);
}
//【落地页】注册页预估额度展示
export async function getGrayLimit (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/get-gray-limit'
  }, data);
  return requestLand.post(`/landing-page/get-gray-limit`, params);
}
//【落地页】注册页预估额度展示
export async function getGrayDownLimit (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/get-gray-limit-v2'
  }, data);
  return checkAb(`/landing-page/get-gray-limit-v2`, params);
}
//落地页判断渠道号是否停用
export async function getUtmSourceInfo (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/get-utm-source-info'
  }, data);
  return checkAb(`/landing-page/get-utm-source-info`, params);
}

// AbTest落地页分发地址
export async function fetchGetUrl (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/get-url'
  }, data);
  return checkAb(`/landing-page/get-url`, params);
}

// 发送验证码 qy-wr

// 落地页-免验证码注册
export async function ifDirectly (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/if-directly'
  }, data);
  return requestLand.post(`/landing-page/if-directly`, params);
}

export async function sendVerifyCode (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/sms-captcha'
  }, data);
  return checkAb(`/landing-page/sms-captcha`, params);
}

// 是否防刷校验 qy-wr
export async function isVerify (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/config'
  }, data);
  return checkAb(`/landing-page/config`, params);
}

// 验证码图片 qy-wr
export async function getImage (params) {
  let data = {
    args: {
      timestamp: new Date(),
    }
  };
  params = Object.assign({
    call: 'landing-page/img-captcha'
  }, data);
  return requestLand.post(`/landing-page/img-captcha`, params);
}

//]前端校验上报 qy-wr
export async function captchaReport (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/captcha-report'
  }, data);
  return requestLand.post(`/landing-page/captcha-report`, params);
}


//注册&归因上报 qy-wr
export async function confirmCode (params) {
  // 切流后参数兜底
  if(!params?.utm_source){
    params.utm_source = 'xyf_mnp_doudi'
  }
  if(!params?.type){
    params.type = '12'
  }
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/confirm-v-code'
  }, data);
  return checkAb(`/landing-page/confirm-v-code`, params);
}


//获取明文手机号
export async function decryptMobile (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/decrypt-mobile'
  }, data);
  return checkAb(`/landing-page/decrypt-mobile`, params, { silentErrorToast: true });
}

// unique_id → 密文手机号（火山），供后续 decrypt-mobile 使用
export async function getVolcanoMobile (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/get-volcano-mobile'
  }, data);
  return checkAb(`/landing-page/get-volcano-mobile`, params, { silentErrorToast: true });
}

export async function decryptMobileJava (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/decrypt-mobile'
  }, data);
  return requestLandProxy.post('/landing-page/decrypt-mobile', params);
}

//脱敏手机号埋点数据上报
export async function reportDecryptMobile (params) {


  if (params && params.report_data) {
    let dealData = params.report_data
    let newDataArr = [];
    let device_model = localStorage.getItem('device_model')

    if (dealData.data) {
      newDataArr = JSON.parse(dealData.data)
      if (newDataArr[0].event_id == 1002163) {
        if (!device_model || true) {  // 配合业务方每次都调用
          let res = await getDeviceModel();
          if (res.status == 1 && res.response) {
            localStorage.setItem('device_model', res.response.device_model)
            newDataArr[0].device_model = res.response.device_model
          }
        } else {
          newDataArr[0].device_model = device_model
        }

      }

      params.report_data.data = JSON.stringify(newDataArr)

    }

  }

  let data = {
    args: params
  };



  params = Object.assign({
    call: 'landing-page/report-decrypt-mobile-data'
  }, data);



  if (params.args && params.args.report_data) {
    params.args.report_data.data = encode(params.args.report_data.data)
  }


  return checkAb(`/landing-page/report-decrypt-mobile-data`, params);
}

// export async function getDeviceModel () {
//   let params = {
//     url: window.location.href
//   }
//   let data = {
//     args: params
//   };
//
//   params = Object.assign({
//     call: 'landing-page/get-device-model'
//   }, data);
//   return checkAb(`/landing-page/get-device-model`, params);
// }
// 新增调用一次获取设备接口
export async function getDeviceModelNew () {
  let params = {
    url: window.location.href,
    reportType:"magic"
  }
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/get-device-model'
  }, data);
  return requestLandDevice.post(`/landing-page/get-device-model`, params);
}

// 归因曝光新接口
export async function getDeviceModelAscribe () {
  let params = {
    url: window.location.href,
    userAgent: navigator.userAgent.trim()
  }
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'adsmonitor/ads-api/collect/h5-tracking/report'
  }, data);
  return requestLandMobileGw.post(`/adsmonitor/ads-api/collect/h5-tracking/report`, params);
}

//判断是否新增调用一次获取设备接口
export async function getDeviceReportHost (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/get-domain-config'
  }, data);
  return requestLand.post(`/landing-page/get-domain-config`, params);
}

//落地页下载地址灰度
export async function getGrayApkInfo (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/get-gray-apk-info'
  }, data);
  return checkAb(`/landing-page/get-gray-apk-info`, params);
}

// 获取优化功能点的ABTEST配置
export async function getAbtestConfig (params) {
  const ab = getLandAb();
  if (!ab) {
    let data = {
      args: params
    };
    params = Object.assign({
      call: 'landing-page/get-optimization-abtest-config'
    }, data);
    return requestLand.post(`/landing-page/get-optimization-abtest-config`, params);
  } else {
    const keys = ['download_page_frate_abtest', 'download_page_header_abtest', 'download_page_popup_abtest', 'download_page_pro_feature_abtest', 'optimization_abtest']
    let data = {
      ua: "h5-client",
      sign: null,
      timeStamp: Date.now(),
      args: keys.map(item => (
          {
            "bizId": getSessionToken(),
            "bizKey": item
          }
      )),
    };
    const res = await requestLandProxy.post(`/ab/bacthQueryAbId`, data)
    if(res.status == 1) {
      let rep = {};
      keys.forEach((key) => {
        rep[key] = (res.response.find(item => item.bizKey === key)).group === 'groupB';
      });
      res.response = rep;
    }
    return Promise.resolve(res)
  }
}

//【落地页】获取放款用户信息
export async function getLoanRecord (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'download-page/get-loan-success-info'
  }, data);
  return requestLandProxy.post(`/download-page/get-loan-success-info`, params);
}

//接入新java额度接口
export async function getGrayDownLimitJava (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'landing-page/get-gray-limit-v2'
  }, data);
  return requestLandProxy.post(`/landing-page/get-gray-limit-v2`, params);
}

//接入新java额度接口
export async function queryLandAb (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: '/ab/queryLandAb'
  }, data);
  return requestLandProxy.post(`/ab/queryLandAb`, params);
}

//获取微信小程序打开链接
export async function getWeiXinUrl (params) {
  let data = {
    args: params
  };
  params = Object.assign({
    call: 'miniapp/queryUrl'
  }, data);
  return requestLandProxyWeiXin.post(`/miniapp/queryUrl`, params);
}